import { getYpaUserData, initializeDioInstance } from '@guestyci/gfh-utils';
import env from 'config/env';

// Note: Context and event names are tracked in a spreadsheet in coordination with the BI team.
// Do not change this value without coordinating with the BI team and project managers.
export const DioContext = {
  LAYOUT_PAGE: 'porter_layout_page',
  DAMAGE_PROTECTION: 'porter_damage_protection',
  PORTER_CREDIT_CARD: 'porter_credit_card',
  CHATBOT: 'porter_chatbot',
  ZENDESK: 'porter_zendesk',
  DYNAMIC_PRICING: 'porter_dpt',
  SMART_LOCKS: 'porter_guesty_locks_manager',
  PORTER_LOGIN_PAGE: 'porter_login_page_version2',
  LOCKED_FLOW: 'porter_lockedflow',
  GUESTY_CAPITAL: 'porter_capital',
};

export const DioType = {
  PAGEVIEW: 'pageview',
  SCREENVIEW: 'screenview',
  CLICK: 'click',
};

class DioInstance {
  private dioRef?: { track: (...args: any[]) => void } = undefined;

  private identified = false;

  private static get baseUrl() {
    return `https://${
      env === 'production' ? 'app' : 'app-staging16'
    }.guesty.com/api`;
  }

  private static get dioData() {
    const userData = getYpaUserData();
    const { email, guestyAccountId, firstName, lastName, ypaUserId } = userData;
    return {
      email,
      guestyAccountId,
      firstName,
      lastName,
      userId: ypaUserId,
    };
  }

  constructor() {
    if (DioInstance.dioData.userId) {
      this.createRef();
    }
  }

  track(...args: any[]) {
    if (this.dioRef === undefined || !this.identified) {
      this.createRef();
    }
    this.dioRef?.track(...args);
  }

  private createRef() {
    this.dioRef = initializeDioInstance(
      DioContext.LAYOUT_PAGE,
      DioInstance.baseUrl,
      DioInstance.dioData
    );
    this.identified = !!DioInstance.dioData.userId;
  }
}

const dio = new DioInstance();

export default dio;
